import { Link, NavLink, Outlet, useLocation, useNavigate } from 'react-router-dom';
import { Compass, NewspaperClipping, Calendar, BookOpen } from 'phosphor-react';
import { hap } from '@/lib/haptics';
import { cn } from '@/lib/cn';
import { useAuth } from '@/hooks/useAuth';

const TABS = [
  { to: '/explorer', label: 'Explorer', Icon: Compass, auth: false },
  { to: '/decouvrir', label: 'À découvrir', Icon: NewspaperClipping, auth: false },
  { to: '/agenda', label: 'Agenda', Icon: Calendar, auth: false },
  { to: '/carnet', label: 'Carnet', Icon: BookOpen, auth: true },
];

export default function Shell() {
  const loc = useLocation();
  const nav = useNavigate();
  const { user } = useAuth();
  // Hide tab bar on detail screens
  const hide = /\/event\//.test(loc.pathname);
  return (
    <div className="min-h-screen bg-paper text-ink-1">
      <main className={cn('relative', !hide && 'pb-tabbar')}>
        <Outlet />
        {!hide && (
          <div className="py-5 px-4 text-center">
            <nav className="flex items-center justify-center gap-3 t-mono-xs text-ink-4" aria-label="Liens légaux">
              <Link to="/mentions">Mentions légales</Link>
              <span aria-hidden>·</span>
              <Link to="/mentions#cgu">CGU</Link>
              <span aria-hidden>·</span>
              <Link to="/mentions#confidentialite">Confidentialité</Link>
            </nav>
          </div>
        )}
      </main>
      {!hide && (
        <nav aria-label="Navigation principale"
          className="fixed bottom-0 left-0 right-0 z-30 blur-chip border-t border-paper-edge"
          style={{ height: 'calc(var(--tabbar-h) + env(safe-area-inset-bottom))', paddingBottom: 'env(safe-area-inset-bottom)' }}>
          <ul className="grid grid-cols-4 h-[var(--tabbar-h)]">
            {TABS.map(({ to, label, Icon, auth }) => {
              const locked = auth && !user;
              if (locked) {
                return (
                  <li key={to}>
                    <button
                      onClick={() => nav('/login', { state: { returnTo: to } })}
                      className="flex flex-col items-center justify-center gap-0.5 h-full w-full relative text-ink-3"
                    >
                      <Icon size={22} weight="regular" />
                      <span className="text-[10.5px] tracking-wide font-sans">{label}</span>
                    </button>
                  </li>
                );
              }
              return (
                <li key={to}>
                  <NavLink to={to} onClick={() => hap.selection()}
                    className={({ isActive }) => cn(
                      'flex flex-col items-center justify-center gap-0.5 h-full relative',
                      isActive ? 'text-ink-1' : 'text-ink-3'
                    )}>
                    {({ isActive }) => (
                      <>
                        <Icon size={22} weight={isActive ? 'fill' : 'regular'} />
                        <span className={cn('text-[10.5px] tracking-wide', isActive ? 'font-serif italic text-[12px]' : 'font-sans')}>{label}</span>
                        {isActive ? <span className="absolute -top-0.5 left-1/2 -translate-x-1/2 w-1 h-1 rounded-full bg-terre" /> : null}
                      </>
                    )}
                  </NavLink>
                </li>
              );
            })}
          </ul>
        </nav>
      )}
    </div>
  );
}
